import { faPlus, faSignal } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "src/components/Button";
import { ServiceTypesTiles } from "./ServiceTypeTiles";
import { CreateButtonWrapper, TabsWrapper } from "../styles";
import { HeaderProps } from "../types";
import WorkRequestBreadCrumbs from "./WorkRequestBreadCrumbs";
import { TilesContainer } from "src/styles";
import styled, { keyframes } from "styled-components";
import { colors } from "src/styles";

const Header = ({
  isBreadCumVisible,
  isCreateNewWorkRequestVisible,
  isServiceTypeVisible,
  countOfServiceType,
  serviceTypes,
  inited,
}: HeaderProps) => {
  const navigate = useNavigate();
  const onAddNewRequestClick = () => {
    navigate("/workrequests/create");
  };
  return (
    <>
      {isBreadCumVisible && <WorkRequestBreadCrumbs />}
      {isServiceTypeVisible && (
        <TilesContainer>
          <ServiceTypesTiles
            serviceTypes={serviceTypes}
            numberOfTilestoDisplay={countOfServiceType}
            isLoading={!inited}
          />
        </TilesContainer>
      )}
      <TabsWrapper>
        {isCreateNewWorkRequestVisible && (
          <CreateButtonWrapper>
            <Button
              text="New Work Request"
              variant="white"
              additionalStyles={{ display: "flex" }}
              icon={faPlus}
              onClick={() => onAddNewRequestClick()}
            />
          </CreateButtonWrapper>
        )}
      </TabsWrapper>

      <OverviewFab onClick={() => navigate("/operational-awareness")} title="Operational Awareness">
        <PulseRing />
        <FabIcon>
          <FontAwesomeIcon icon={faSignal} />
        </FabIcon>
        <FabLabel>Overview</FabLabel>
      </OverviewFab>
    </>
  );
};

export default Header;

// ─── Animations ────────────────────────────────────────────────────────────────

const pulse = keyframes`
  0%   { transform: scale(1);   opacity: 0.55; }
  70%  { transform: scale(1.9); opacity: 0; }
  100% { transform: scale(1.9); opacity: 0; }
`;

const expandLabel = keyframes`
  from { opacity: 0; max-width: 0; margin-left: 0; }
  to   { opacity: 1; max-width: 80px; margin-left: 8px; }
`;

// ─── Styled components ─────────────────────────────────────────────────────────

const OverviewFab = styled.button`
  position: fixed;
  bottom: 36px;
  right: 36px;
  z-index: 200;

  display: flex;
  align-items: center;
  justify-content: center;

  height: 48px;
  padding: 0 16px 0 14px;
  border-radius: 24px;
  border: none;
  background: ${colors.black.dark1};
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 4px 18px rgba(0, 0, 0, 0.22);
  transition:
    background 0.2s,
    box-shadow 0.2s,
    transform 0.15s;

  &:hover {
    background: #2d2d2d;
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.3);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  }

  /* Show label on hover */
  &:hover > span:last-child {
    animation: ${expandLabel} 0.2s ease forwards;
    display: inline-block;
  }
`;

const PulseRing = styled.span`
  position: absolute;
  width: 48px;
  height: 48px;
  border-radius: 24px;
  background: ${colors.black.dark1};
  animation: ${pulse} 2.4s ease-out infinite;
  pointer-events: none;
`;

const FabIcon = styled.span`
  position: relative;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
`;

const FabLabel = styled.span`
  display: none;
  overflow: hidden;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.02em;
`;
